export const locale = {
    lang: 'tr',
    data: {
        'NAV': {
            'APPLICATIONS': 'Programlar',
            'SAMPLE'        : {
                'TITLE': 'Örnek',
                'BADGE': '15'
            }
        }
    }
};



// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/app/navigation/i18n/tr.ts